import React from "react";

const UserListIcon = ({
  color = "#2B2B2B",
  width = "100%",
  height = "100%"
}) => {

  return (
    <svg
      className="icon userListIcon"
      width={width}
      height={height}
      viewBox="0 0 15 16"
      fill="none"
    >
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
          <path
            d="M14.2675629,14.0351562 C14.6718682,14.0351562 15,14.3632812 15,14.7675781 C15,15.171875 14.6718682,15.5 14.2675629,15.5 L14.2675629,15.5 L10.9217902,15.5 C10.5174849,15.5 10.1893531,15.171875 10.1893531,14.7675781 C10.1893531,14.3632812 10.5174849,14.0351562 10.9217902,14.0351562 L10.9217902,14.0351562 Z M2.36692487,9.3828125 C2.68040795,9.125 3.14037845,9.171875 3.39819631,9.48242188 C3.65601417,9.79589844 3.60913819,10.2558594 3.29858486,10.5136719 C2.41673059,11.2402344 1.78976443,12.2070312 1.48800034,13.3027344 C1.43819462,13.4785156 1.4733516,13.6630859 1.58468204,13.8095703 C1.64913651,13.8945312 1.79269418,14.0351562 2.03879305,14.0351562 L2.03879305,14.0351562 L8.15317797,14.0351562 C8.55748325,14.0351562 8.88561507,14.3632812 8.88561507,14.7675781 C8.88561507,15.171875 8.55748325,15.5 8.15317797,15.5 L8.15317797,15.5 L2.03879305,15.5 C1.39717814,15.5 0.808298714,15.2070312 0.418642176,14.6972656 C0.028985638,14.1875 -0.0969935435,13.5371094 0.0758616126,12.9130859 C0.456728906,11.5244141 1.25069072,10.3056641 2.36692487,9.3828125 Z M14.2675629,11.3984375 C14.6718682,11.3984375 15,11.7265625 15,12.1308594 C15,12.5351562 14.6718682,12.8632812 14.2675629,12.8632812 L14.2675629,12.8632812 L10.9217902,12.8632812 C10.5174849,12.8632812 10.1893531,12.5351562 10.1893531,12.1308594 C10.1893531,11.7265625 10.5174849,11.3984375 10.9217902,11.3984375 L10.9217902,11.3984375 Z M14.2675629,8.76171875 C14.6718682,8.76171875 15,9.08984375 15,9.49414062 C15,9.8984375 14.6718682,10.2265625 14.2675629,10.2265625 L14.2675629,10.2265625 L10.9217902,10.2265625 C10.5174849,10.2265625 10.1893531,9.8984375 10.1893531,9.49414062 C10.1893531,9.08984375 10.5174849,8.76171875 10.9217902,8.76171875 L10.9217902,8.76171875 Z M6.8054937,0.5 C9.13464369,0.5 11.0301909,2.39550781 11.0331207,4.72753906 C11.0331207,7.05957031 9.13757344,8.95507812 6.8054937,8.95507812 C4.47341397,8.95507812 2.57786675,7.05664062 2.57786675,4.72753906 C2.57786675,2.39550781 4.47341397,0.5 6.8054937,0.5 Z M6.8054937,1.96484375 C5.28202453,1.96484375 4.04274096,3.20410156 4.04274096,4.72753906 C4.04274096,6.25097656 5.28202453,7.49023437 6.8054937,7.49023437 C8.32603313,7.49023437 9.56824645,6.25097656 9.56824645,4.72753906 C9.56824645,3.20410156 8.32896288,1.96484375 6.8054937,1.96484375 Z"
            fill={color}
            fillRule="nonzero"
          >
          </path>
      </g>
    </svg>
  );
};

export default UserListIcon;
